import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { KeyRound } from 'lucide-react';
import '../crm.css';

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('coreestimation94@gmail.com');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (user && user !== false) {
      const dest = location.state?.from || '/crm/dashboard';
      navigate(dest, { replace: true });
    }
  }, [user, navigate, location]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr(''); setBusy(true);
    const res = await login(email.trim(), password);
    setBusy(false);
    if (!res.ok) setErr(res.error);
    else navigate(location.state?.from || '/crm/dashboard', { replace: true });
  };

  return (
    <div className="crm-login-wrap">
      <form className="crm-login" onSubmit={onSubmit} data-testid="crm-login-form">
        <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginBottom: 18 }}>
          <img
            src="/logo.png"
            alt="Core Estimation"
            style={{ width: 56, height: 56, borderRadius: 12, background: 'var(--crm-indigo-soft)', padding: 6, objectFit: 'contain' }}
          />
          <div>
            <h1>Core Estimation CRM</h1>
            <p className="sub" style={{ margin: 0 }}>Sign in to manage leads &amp; deals</p>
          </div>
        </div>

        {err && <div className="err" data-testid="crm-login-error">{err}</div>}

        <div className="field">
          <label className="crm-label">Email</label>
          <input
            type="email" required autoFocus className="crm-input"
            value={email} onChange={(e) => setEmail(e.target.value)}
            data-testid="crm-login-email"
          />
        </div>
        <div className="field">
          <label className="crm-label">Password</label>
          <input
            type="password" required className="crm-input"
            value={password} onChange={(e) => setPassword(e.target.value)}
            data-testid="crm-login-password"
          />
        </div>

        <button type="submit" className="crm-btn" disabled={busy} style={{ width: '100%', justifyContent: 'center', height: 42 }} data-testid="crm-login-submit">
          <KeyRound size={16} /> {busy ? 'Signing in…' : 'Sign in'}
        </button>

        <p style={{ marginTop: 16, fontSize: 11.5, color: 'var(--crm-muted)', textAlign: 'center' }}>
          For team access, ask the admin to create your account.
        </p>
      </form>
    </div>
  );
}
